module.exports = __webpack_public_path__ + "static/media/480.c28e1444.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-caterpillar/light/480.png
// module id = 1932
// module chunks = 2